import * as tslib_1 from "tslib";
import * as orders from '../actions/orders';
import { generateEntities } from '../../core/helpers/entities';
import { createSelector } from '@ngrx/store';
var initialState = {
    expanding: false,
    loading: false,
    canExpand: false,
    lastLineId: null,
    lines: {},
    currentPage: 1,
    nextPage: 2,
    totalPages: 1,
    total: 0,
    numbers: [],
    orders: {}
};
export function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    var _a;
    var wrap;
    var generatedData;
    switch (action.type) {
        case orders.ADD:
            var order = action.payload;
            return tslib_1.__assign({}, state, { numbers: state.numbers.concat([order._id]), orders: tslib_1.__assign({}, state.orders, (_a = {}, _a[order._id] = order, _a)) });
        case orders.LOAD:
            return tslib_1.__assign({}, state, { loading: true, lastLineId: null, lines: {} });
        case orders.LOAD_SUCCESS:
            wrap = action.payload;
            generatedData = generateEntities(wrap);
            return tslib_1.__assign({}, state, { loading: false, numbers: generatedData.ids, lines: generatedData.entities, currentPage: 1, nextPage: 2, totalPages: generatedData.totalPages, total: generatedData.totalCount });
        case orders.LOAD_FAILED:
            return tslib_1.__assign({}, state, { loading: false });
        case orders.EXPAND: {
            if ((state.total === state.numbers.length) || !state.total) {
                return tslib_1.__assign({}, state, { expanding: false });
            }
            else {
                return tslib_1.__assign({}, state, { expanding: true });
            }
        }
        case orders.EXPAND_SUCCESS:
            wrap = action.payload;
            generatedData = generateEntities(wrap);
            return tslib_1.__assign({}, state, { expanding: false, numbers: state.numbers.concat(generatedData.ids), lines: tslib_1.__assign({}, state.lines, generatedData.entities), currentPage: ++state.currentPage, nextPage: ++state.nextPage });
        case orders.EXPAND_FAILED:
            return tslib_1.__assign({}, state, { expanding: false });
        default:
            return state;
    }
}
// Deprecated
export var getOrderNumbers = function (state) { return state && state.numbers; };
export var getOrdersIndexed = function (state) { return state.orders; };
// Public Selectors
export var isExpanding = function (state) { return state.expanding; };
export var isLoading = function (state) { return state.loading; };
export var getLastLineId = function (state) { return state.lastLineId; };
export var getLines = function (state) { return state && state.lines; };
export var getLineCount = function (state) { return state.lines.length; };
export var canExpand = function (state) { return state.totalPages > state.currentPage; };
export var getAll = createSelector(getLines, getOrderNumbers, function (orders, ids) { return ids.map(function (id) { return orders[id]; }); });
